// extracted by mini-css-extract-plugin
export default {"btnStyle":"ReopenDC_btnStyle__AUFEy","position":"ReopenDC_position__8Js96","selectStyle":"ReopenDC_selectStyle__3Xsw8","textArea":"ReopenDC_textArea__vO1XW"};